import React from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import { SubmitButton, ButtonArea } from 'lp-components'
import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  acknowledged: Yup.boolean()
    .oneOf([true], 'You must acknowledge receipt of all documents to proceed.')
    .required(),
})

function HudBrochureAckForm({ initialValues, onSubmit }) {
  const alreadyAcknowledged = !!initialValues?.tenantApplication?.brochuresReceived

  return (
    <Formik
      initialValues={{ acknowledged: alreadyAcknowledged }}
      validationSchema={validationSchema}
      onSubmit={async (_values, { setSubmitting }) => {
        await onSubmit()
        setSubmitting(false)
      }}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <div className="form-check mt-5 mb-4" style={{ fontSize: '1.05rem' }}>
            <Field
              type="checkbox"
              name="acknowledged"
              id="acknowledged"
              className="form-check-input"
            />
            <label className="form-check-label ms-2" htmlFor="acknowledged">
              By signing this form, I acknowledge that I have received all of the forms
              and/or documents indicated above, and I have been given the opportunity to
              ask questions about the information provided in each of these documents.
            </label>
            {errors.acknowledged && touched.acknowledged && (
              <div className="invalid-feedback d-block">{errors.acknowledged}</div>
            )}
          </div>
          <ButtonArea>
            <SubmitButton submitting={isSubmitting}>Next</SubmitButton>
          </ButtonArea>
        </Form>
      )}
    </Formik>
  )
}

HudBrochureAckForm.propTypes = {
  initialValues: PropTypes.shape({
    tenantApplication: PropTypes.shape({
      brochuresReceived: PropTypes.string,
    }),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default HudBrochureAckForm
